import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(() => ({
  pawHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Dosis', sans-serif",
    fontWeight: 800,
    margin: '0 0 40px',
    '& img': {
      width: '24px',
      margin: '0px',
    },
    '& .paw-36': {
      width: '36px',
    },
    '& .black-48': {
      fontSize: '48px',
      lineHeight: '48px',
      color: '#2B1C2F',
      margin: '0 8px',
    },
    '& .black-36': {
      fontSize: '36px',
      lineHeight: '36px',
      color: '#2B1C2F',
      margin: '0 8px',
    },
    '& .black-24': {
      fontSize: '24px',
      lineHeight: '24px',
      color: '#2B1C2F',
      margin: '0 8px',
    },
    '& .black-18': {
      fontSize: '18px',
      lineHeight: '18px',
      color: '#2B1C2F',
      margin: '0 8px',
    },

    '& .gray-48': {
      fontSize: '48px',
      lineHeight: '48px',
      color: '#52494C',
    },
    '& .gray-36': {
      fontSize: '36px',
      lineHeight: '36px',
      color: '#52494C',
    },
    '& .gray-24': {
      fontSize: '24px',
      lineHeight: '24px',
      color: '#52494C',
    },
    '& .gray-18': {
      fontSize: '18px',
      lineHeight: '18px',
      color: '#52494C',
    },
  },
}))

const PawHeader = (props) => {
  const classes = useStyles()
  const { color, size, text, textColor, textSize } = props
  const className = `${textColor}-${textSize}`
  const pawClassName = `paw-${size}`

  return (
    <span className={classes.pawHeader}>
      <img
        className={pawClassName}
        src={color === 'white' ? '/images/icons/white-paw.svg' : '/images/icons/pink-paw.svg'}
        style={{ opacity: color === 'soft-pink' ? '0.4' : '1' }}
        alt="paw"
      />
      <span className={className}>{text}</span>
      <img
        className={pawClassName}
        src={color === 'white' ? '/images/icons/white-paw.svg' : '/images/icons/pink-paw.svg'}
        style={{ opacity: color === 'soft-pink' ? '0.4' : '1' }}
        alt="paw"
      />
    </span>
  )
}

export default PawHeader
